import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import CalendarContext from "./calendarContext";
import { jsx as ___EmotionJSX } from "@emotion/core";

function asCalendarConsumer(WrappedComponent) {
  var CalendarConsumer = function (_Component) {
    _inherits(CalendarConsumer, _Component);

    var _super = _createSuper(CalendarConsumer);

    function CalendarConsumer() {
      _classCallCheck(this, CalendarConsumer);

      return _super.apply(this, arguments);
    }

    _createClass(CalendarConsumer, [{
      key: "render",
      value: function render() {
        var _this = this;

        return ___EmotionJSX(CalendarContext.Consumer, null, function (context) {
          return ___EmotionJSX(WrappedComponent, _extends({
            ref: function ref(r) {
              return _this.contentRef = r;
            },
            context: context
          }, _this.props));
        });
      }
    }]);

    return CalendarConsumer;
  }(Component);

  hoistNonReactStatic(CalendarConsumer, WrappedComponent);
  return CalendarConsumer;
}

export default asCalendarConsumer;

if (typeof asCalendarConsumer !== 'undefined' && asCalendarConsumer && asCalendarConsumer === Object(asCalendarConsumer) && Object.isExtensible(asCalendarConsumer) && !asCalendarConsumer.hasOwnProperty('__filemeta')) {
  Object.defineProperty(asCalendarConsumer, '__filemeta', {
    configurable: true,
    value: {
      name: "asCalendarConsumer",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/asCalendarConsumer.js"
    }
  });
}